<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-user mr-2" />User</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Kategori">
                        <multiselect v-model="filter.type"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="filter.options"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Pencarian">
                        <multiselect
                            v-if="!$helper.isBlank(filter.type) && filter.type.id == 'isActive'"
                            v-model="filter.isActive"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="filter.isActiveOptions"
                            @input="getItems"
                        />
                        <multiselect
                            v-else-if="!$helper.isBlank(filter.type) && filter.type.id == 'isAfterhour'"
                            v-model="filter.isAfterhour"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="filter.isAfterhourOptions"
                            @input="getItems"
                        />
                        <multiselect
                            v-else-if="!$helper.isBlank(filter.type) && filter.type.id == 'role'"
                            v-model="filter.role"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="filter.roleOptions"
                            @input="getItems"
                        />
                        <b-form-input v-else v-model="filter.fullname" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <!-- <b-col md="3">
                    <b-form-group label="Status Aktif">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col> -->
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />User Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                no-local-sorting no-sort-reset
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data user.
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.fullname }}
                    <div class="small">{{ row.item.username }}</div>
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge v-if="row.item.is_active == 1" variant="success">AKTIF</b-badge>
                    <b-badge v-else variant="danger">NON-AKTIF</b-badge>
                </template>
                <template v-slot:cell(isAfterhourAllowed)="row">
                    <b-badge v-if="row.item.is_afterhour_allowed == 1" variant="primary">DIIZINKAN</b-badge>
                    <b-badge v-else variant="dark">TIDAK DIIZINKAN</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Reset Password" @click="resetPassword(row.item)">
                        <i class="fa fa-fw fa-key" />
                    </b-button>
                    <b-button size="sm" v-if="row.item.is_active == 1" class="ml-2" variant="danger" v-b-tooltip.hover.top title="Non-aktifkan" @click="switchActive(row.item)">
                        <i class="fa fa-fw fa-power-off" />
                    </b-button>
                    <b-button size="sm" v-if="row.item.is_active == 0" class="ml-2" variant="success" v-b-tooltip.hover.top title="Aktifkan" @click="switchActive(row.item)">
                        <i class="fa fa-fw fa-power-off" />
                    </b-button>
                    <b-button size="sm" v-if="row.item.is_afterhour_allowed == 1" class="ml-2" variant="danger" v-b-tooltip.hover.top title="Matikan Akses" @click="switchAfterhour(row.item)">
                        <i class="fa fa-fw fa-history" />
                    </b-button>
                    <b-button size="sm" v-if="row.item.is_afterhour_allowed == 0" class="ml-2" variant="success" v-b-tooltip.hover.top title="Izinkan Akses" @click="switchAfterhour(row.item)">
                        <i class="fa fa-fw fa-history" />
                    </b-button>
                    <b-button size="sm" variant="warning" class="ml-2" v-b-tooltip.hover.top title="Edit Divisi" @click="prepareEditDivision(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="warning" class="ml-2" v-b-tooltip.hover.top title="Edit Office" @click="prepareEditOffice(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah User Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Username" description="Username digunakan untuk login.">
                <b-input v-model="input.username" maxlength="100" />
            </b-form-group>
            <b-form-group label="Nama" description="Nama user yang dimunculkan di program.">
                <b-input v-model="input.fullname" maxlength="100" />
            </b-form-group>
            <b-form-group label="Role">
                <b-form-select v-model="input.roleId" :options="optRole">
                    <template #first>
                        <b-form-select-option value=0 disabled>Pilih role...</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-alert variant="info" show>
                Password user baru sama dengan usernamenya. Mohon infokan user untuk langsung merubah password!
            </b-alert>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Role" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah user <strong>{{ activeItem.fullname }}</strong>
            <b-form-group label="Username" description="Username digunakan untuk login.">
                <b-input v-model="edit.username" maxlength="100" />
            </b-form-group>
            <b-form-group label="Nama" description="Nama user yang dimunculkan di program.">
                <b-input v-model="edit.fullname" maxlength="100" />
            </b-form-group>
            <b-form-group label="Role">
                <b-form-select v-model="edit.roleId" :options="optRole">
                    <template #first>
                        <b-form-select-option value=0 disabled>Pilih role...</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit-division" title="Edit Divisi" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Divisi yang dipilih">
                <b-form-checkbox-group
                    v-model="editDivision.divisions"
                    :options="optDivision"
                    stacked
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEditDivision">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit-office" title="Edit Office" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Lokasi office yang dipilih">
                <b-form-checkbox-group
                    v-model="editOffice.offices"
                    :options="optOffice"
                    stacked
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEditOffice">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                type: null,
                options: [
                    { id: "fullname", name: "Nama Lengkap" },
                    { id: "role", name: "Role" },
                    { id: "isActive", name: "Status Aktif" },
                    { id: "isAfterhour", name: "Akses Luar Jam" },
                ],
                fullname: "",
                role: null,
                roleOptions: [],
                isActive: null,
                isActiveOptions: [
                    { id: 0, name: "Non-Aktif" },
                    { id: 1, name: "Aktif" }
                ],
                isAfterhour: null,
                isAfterhourOptions: [
                    { id: 0, name: "Tidak Diizinkan" },
                    { id: 1, name: "Diizinkan" }
                ]
            },

            input: {
                username: "",
                fullname: "",
                roleId: null
            },

            edit: {
                username: "",
                fullname: "",
                roleId: null
            },

            editDivision: {
                divisions: []
            },
            editOffice: {
                offices: []
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Lengkap & Username", sortable: true },
                { key: "role", label: "Role", sortable: true },
                { key: "isActive", label: "Status Aktif", sortable: true },
                { key: "isAfterhourAllowed", label: "Akses Luar Jam Kerja", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optRole: [],

            optDivision: [],
            optOffice: [],

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getRoles = this.$axios.get("role/selection").then(res => {
                this.optRole = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
            })
            let getRolesFilterOptions = this.$axios.get("role").then(res => {
                this.filter.roleOptions = res.data.data.items.map(it => {
                    return { id: it.id, name: it.name }
                })
            })

            let getDivisions = this.$axios.get("division/get-all").then(res => {
                this.optDivision = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
            })

            let getOffices = this.$axios.get("master/offices").then(res => {
                this.optOffice = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
            })

            Promise.all([getItems, getRoles, getRolesFilterOptions, getDivisions, getOffices]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => {
                this.initStatus = -1
            })

        },

        confirmCreate() {

            if(this.$helper.isBlank(this.input.username)) {
                return this.$helper.toastError(this, "Username tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.fullname)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.input.roleId == 0) {
                return this.$helper.toastError(this, "Mohon memilih role!")
            }

            let isConfirmed = confirm("Simpan user baru ini?")
            if(!isConfirmed) return

            let payload = {
                username: this.input.username,
                fullname: this.input.fullname,
                roleId: this.input.roleId
            }

            this.isSubmitting = true
            this.$axios.post("user", payload).then(res => {

                this.$helper.toastSuccess(this, "User baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.username = ""
                this.input.fullname = ""
                this.input.roleId = 0
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.fullname = item.fullname
            this.edit.username = item.username
            this.edit.roleId = item.roleId
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.username)) {
                return this.$helper.toastError(this, "Username tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.edit.fullname)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.edit.roleId == 0) {
                return this.$helper.toastError(this, "Mohon memilih role!")
            }

            let isConfirmed = confirm("Simpan perubahan user ini?")
            if(!isConfirmed) return

            let payload = {
                username: this.edit.username,
                fullname: this.edit.fullname,
                roleId: this.edit.roleId
            }

            this.isSubmitting = true
            this.$axios.post("user/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "User berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        switchActive(item) {

            let prepend = item.is_active == 1 ? "Non-aktifkan" : "Aktifkan"
            let append = item.is_active == 1 ? "dinon-aktifkan!" : "diaktifkan!"
            let targetActive = item.is_active == 1 ? 0 : 1

            let isConfirmed = confirm(`${prepend} user ${item.fullname}?`)
            if(!isConfirmed) return

            let payload = {
                id: item.id
            }

            this.$axios.post("user/flip-status", payload).then(_ => {
                this.$helper.toastSuccess(this, item.fullname + " berhasil " + append)
                item.is_active = targetActive
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        switchAfterhour(item) {

            let prepend = item.is_afterhour_allowed == 1 ? "Matikan izin" : "Izinkan"
            let append = item.is_afterhour_allowed == 1 ? "dimatikan izinnya!" : "diizinkan!"
            let targetActive = item.is_afterhour_allowed == 1 ? 0 : 1

            let isConfirmed = confirm(`${prepend} akses luar jam kerja user ${item.fullname}?`)
            if(!isConfirmed) return

            let payload = {
                id: item.id
            }

            this.$axios.post("user/flip-afterhour", payload).then(_ => {
                this.$helper.toastSuccess(this, item.fullname + " berhasil " + append)
                item.is_afterhour_allowed = targetActive
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        resetPassword(item) {

            let isConfirmed = confirm("Reset password " + item.fullname + "? Password akan diubah sesuai dengan usernamenya!")
            if(!isConfirmed) return

            let payload = {
                id: item.id
            }

            this.$axios.post("user/reset-password", payload).then(_ => {
                this.$helper.toastSuccess(this, item.fullname + " berhasil direset passwordnya!")
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                if(this.sortBy == "name") {
                    param += "&sortBy=fullname"
                    if(this.sortDesc) {
                        param += "&sortOrder=desc"
                    }
                    else {
                        param += "&sortOrder=asc"
                    }
                }
                else if(this.sortBy == "role") {
                    param += "&sortBy=roles.name"
                    if(this.sortDesc) {
                        param += "&sortOrder=desc"
                    }
                    else {
                        param += "&sortOrder=asc"
                    }
                }
                else if(this.sortBy == "isActive") {
                    param += "&sortBy=is_active"
                    if(this.sortDesc) {
                        param += "&sortOrder=asc"
                    }
                    else {
                        param += "&sortOrder=desc"
                    }
                }
                else if(this.sortBy == "isAfterhourAllowed") {
                    param += "&sortBy=is_afterhour_allowed"
                    if(this.sortDesc) {
                        param += "&sortOrder=asc"
                    }
                    else {
                        param += "&sortOrder=desc"
                    }
                }
            }

            if(!this.$helper.isBlank(this.filter.type)) {
                if(this.filter.type.id == "fullname" && !this.$helper.isBlank(this.filter.fullname)) {
                    param += "&filterFullname=" + this.filter.fullname
                }
                else if(this.filter.type.id == "role" && !this.$helper.isBlank(this.filter.role)) {
                    param += "&filterRole=" + this.filter.role.id
                }
                else if(this.filter.type.id == "isActive" && !this.$helper.isBlank(this.filter.isActive)) {
                    param += "&filterIsActive=" + this.filter.isActive.id
                }
                else if(this.filter.type.id == "isAfterhour" && !this.$helper.isBlank(this.filter.isAfterhour)) {
                    param += "&filterAfterhour=" + this.filter.isAfterhour.id
                }
            }

            return this.$axios.get("user" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listUserFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        prepareEditDivision(item) {
            this.activeItem = item
            this.editDivision.divisions = item.divisionIds
            this.$bvModal.show("m-edit-division")
        },

        confirmEditDivision() {

            let isConfirmed = confirm("Simpan perubahan user ini?")
            if(!isConfirmed) return

            let payload = {
                userId: this.activeItem.id,
                divisionIds: this.editDivision.divisions
            }

            this.isSubmitting = true
            this.$axios.post("user/update-division", payload).then(res => {

                this.$helper.toastSuccess(this, "User berhasil diubah!")
                this.$bvModal.hide("m-edit-division")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },
        
        prepareEditOffice(item) {
            this.activeItem = item
            this.editOffice.offices = item.officeIds
            this.$bvModal.show("m-edit-office")
        },

        confirmEditOffice() {

            let isConfirmed = confirm("Simpan perubahan user ini?")
            if(!isConfirmed) return

            let payload = {
                userId: this.activeItem.id,
                officeIds: this.editOffice.offices
            }

            this.isSubmitting = true
            this.$axios.post("user/update-office", payload).then(res => {

                this.$helper.toastSuccess(this, "User berhasil diubah!")
                this.$bvModal.hide("m-edit-office")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },       

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listUserFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listUserFilter"))
        }
        this.init()
    }
}
</script>
